import { IRootState } from "state-manager/reducers/root-reducer"

export const userIdSelector = (state: IRootState) => state.userData.id

export const isDemoAccount = (userId: any) => userId === Number(process.env.REACT_APP_DEMO_USER_ID)
